import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

export function depositManagerList(data) { return axios.post(`${base.url}/payment/depositManager/list`, qs.stringify(data)) }
export function depositManagerStats(data) { return axios.post(`${base.url}/payment/depositManager/stats`, qs.stringify(data)) }
export function depositManagerStatusCounts(data) { return axios.post(`${base.url}/payment/depositManager/statusCounts`, qs.stringify(data)) }
export function depositManagerBatchReview(ids, reviewStatus) { return axios.post(`${base.url}/payment/depositManager/batchReview`, qs.stringify({ ids, reviewStatus })) }
export function depositManagerExport(data) { return axios.post(`${base.url}/payment/depositManager/export`, qs.stringify(data), { responseType: 'blob' }) }
